// @flow
import React, {useContext, useEffect, useState} from 'react';
import {Redirect, useHistory, useParams} from "react-router-dom";
import Header from "../Header";
import BackButton from "../../GUI_COMMON/COMPONENTS/BackButton";
import TextInput from "../../GUI_COMMON/COMPONENTS/TextInput";
import LIButton from "../../GUI_COMMON/COMPONENTS/LIButton";
import Popup from "../../GUI_COMMON/COMPONENTS/Popup";
import ErrorPopup from "../../GUI_COMMON/COMPONENTS/ErrorPopup";
import {StoreContext} from "../../GUI_COMMON/SUPPORT/store";
import ArchiverClientApi from "../../API/archiverClientApi";
import ArchiverGuiUtils from "../../SUPPORT/ArchiverGuiUtils";
import {gotAddNewSampleType, gotRemoveSampleType, gotUpdateSampleType} from "../../ACTIONS/clientActions";
import {gotSampleTypes} from "../../GUI_COMMON/ACTIONS/commonClientActions";
import ImageSetterCard from "../ImageSetterCard";
import {ImageInfoStruct} from "../ImageInfoStruct";
//import {fi} from "date-fns/locale";

const SampleTypesAdminPage = () => {
    
    const [globalState, dispatch] = useContext(StoreContext);
    
    const [curSampleTypeDetails, setCurSampleTypeDetails] = useState(getDefaultSampleTypeDetails());
    const [fullSampleTypesList, setFullSampleTypesList] = useState([]);
    
    const [isDirty, setIsDirty] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isRemoving, setIsRemoving] = useState(false);
    const [pSetImage, setPSetImage] = useState(new ImageInfoStruct());

    const [redirectToPage, setRedirectToPage] = useState();
    
    const history = useHistory();

    const {sampleTypeId} = useParams();
    const [selectedSampleType, setSelectedSampleType] = useState(sampleTypeId?Number(sampleTypeId):null);
    
    useEffect(() => {
        console.debug("refreshing sample types list");
        if(globalState.sampleTypes && globalState.sampleTypes.initialized) {
            setFullSampleTypesList(globalState.sampleTypes.items);
            setIsDirty(false);
        }
        else {
            loadSampleTypes();
        }
    }, [globalState.sampleTypes]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect( () => {
        if(fullSampleTypesList && fullSampleTypesList.length>0) {
            doRealListItemClicked(selectedSampleType);  // preselect if the url has soemthign in it.
        }
    },[fullSampleTypesList,selectedSampleType]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    function loadSampleTypes() {
        setIsLoading(true);
        
        ArchiverClientApi.sendSampleTypesRequest()
        .then( (results) => {
            dispatch(gotSampleTypes(results)); // save for possible later use
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => setIsLoading(false));
    }
    function getDefaultSampleTypeDetails():{} {
        return(
            {
                id: null,
                name: "",
                description: "",
                imageData: null,
            }
        );
    }
    
    function handleCancelClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        
        confirmClearDirty();
    }
    
    function confirmClearDirty() {
        if(isDirty) {
            Popup.showConfirm("Cancel?","You have changed some information.","Forget changes",null,
                () => {
                    resetSampleTypeDetailsShown();
                });
        }
        else {
            resetSampleTypeDetailsShown(); // just clear what's there
        }
    }
    
    function handleDeleteSampleTypeClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        
        Popup.showConfirm("Delete SampleType?",`<p>This will remove '${curSampleTypeDetails.name}' completely from the system.</p>`+
                                "<p>You will be unable to remove this type if it is currently in use by any mag types.</p>"+
                                "<p>Are you sure you want to do this?</p>","Yes, Delete it",null, 
            () => {
               doSampleTypeRemove(curSampleTypeDetails.name,curSampleTypeDetails.id);
            });
    }
   
    function doSampleTypeRemove(sampleTypeName, sampleTypeId) {
        setIsRemoving(true);
        ArchiverClientApi.sendSampleTypeRemove(sampleTypeId)
        .then(() => {
            Popup.showInfo(`SampleType '${sampleTypeName}' removed`);
            dispatch(gotRemoveSampleType(sampleTypeId));
            resetSampleTypeDetailsShown();
        })
        .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally(() => {
            setIsRemoving(false);
        });
    }
    
    function handleSaveClicked(e,action) {
        e.preventDefault();
        e.stopPropagation();
        
        if(!checkForValid()) {
            return;
        }
        
        setIsSaving(true);
        ArchiverClientApi.sendSampleTypeUpdate(fixValues())
        .then( (savedSampleTypeInfo) => {
            Popup.showInfo(`SampleType '${curSampleTypeDetails.name}' Saved`);
            clearDirtyFlags();
            if(action==="ADD") {
                dispatch(gotAddNewSampleType(savedSampleTypeInfo));
                //resetSampleTypeDetailsShown(savedSampleTypeInfo.id);
            }
            else if(action==="UPDATE") {
                dispatch(gotUpdateSampleType(savedSampleTypeInfo));
            }
            setSelectedSampleType(savedSampleTypeInfo.id);


        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => {
           setIsSaving(false); 
        });
    }
    
    function checkForValid():boolean {
        let isValid=true;
        let notValidMsg="";
        if(curSampleTypeDetails.name==="") {
            isValid=false;
            notValidMsg="Name needs to be non-blank";
        }
        
        if(!isValid) {
            ErrorPopup.showError("Validation Problem",notValidMsg);
            return false;
        }
        return true;

    }
    
    function fixValues():{} {
        const editInfo = {...curSampleTypeDetails};
        
        if(editInfo.destinationMagSampleTypeId<0) {
            editInfo.destinationMagSampleTypeId=null; // none
        }
        
        return editInfo;
    }
    
    function onChange(e) {
        const thing = e.target.name;
        const editInfo = {...curSampleTypeDetails};
        if(e.target.type==="checkbox") { // this is a checkbox
            editInfo[thing] = e.target.checked;
        }
        else {
            editInfo[thing] = e.target.value;
        }
        setCurSampleTypeDetails(editInfo);
        setIsDirty(true);
    }
    
    function showSampleTypesList(listContents:[]) {

        if(isLoading) {
            return <div className="pr-4 w-30 li-border-right-light">...loading...</div>;
        }
        
        listContents.sort( (a,b) => {
           if(a.type<b.type) return -1;
           if(a.type>b.type) return 1;
           return 0;
        });
        
        let resultList = listContents?.map((item,index) => {
            let extraClass = "";
            if(curSampleTypeDetails?.id===item.id) {
                extraClass += " li-bg-light";
            }
                return <li key={index} className={"list-group-item li-pointer"+extraClass}
                    onClick={() => handleListItemClicked(item)}>
                    {item.name}
                </li>;
            }
        );
        if(!resultList || resultList.length===0) {
            resultList = "no sample types found";
        }

        return (
            <div className="pr-4 w-30 li-border-right-light">
                <h4>SampleTypes</h4>
                <div className="li-scrollable-at-500 ">
                    <ul className="list-group-flush li-list-group-w-hover pl-0">
                        {resultList}
                    </ul>
                    <div className="li-border-line-light"/>
                </div>
                <LIButton small primary label="" bgClass={isRemoving?"ml-3 my-3":"fa fa-trash ml-3 my-3"} disabled={curSampleTypeDetails?.id===null}
                          onClick={handleDeleteSampleTypeClicked} showBusy={isRemoving}/>
                <LIButton small primary label="" bgClass={isRemoving?"":"fa fa-plus m-3"} onClick={confirmClearDirty} showBusy={false}/>
            </div>
        );
    }
    
    function handleListItemClicked(item) {
        if(isDirty) {
            Popup.showConfirm("Cancel?","You have changed some information.","Forget changes",null,
                () => {
                    resetSampleTypeDetailsShown();
                    doRealListItemClicked(item?.id);
                });
        }
        else {
            doRealListItemClicked(item?.id);
        }
    }
    
    function doRealListItemClicked(itemId) {
        const sampleType = fullSampleTypesList.find(i => i.id===itemId);
        if(!sampleType) {
            resetSampleTypeDetailsShown();
        }
        else {
            setCurSampleTypeDetails(sampleType);
            const imageInfo = new ImageInfoStruct();
            imageInfo.SetupBasedOnEncodedBytes(sampleType.imageData);
            setPSetImage(imageInfo);
            updateUrlLink(`/admin/sample_types/${sampleType.id}`);
        }
    }
    
    function updateUrlLink(toThis) {
        history.replace(toThis);
    }
    
    function resetSampleTypeDetailsShown(newId:number=null) {
        setCurSampleTypeDetails(getDefaultSampleTypeDetails());
        setSelectedSampleType(null);
        clearDirtyFlags();
        updateUrlLink("/admin/sample_types"+(newId===null?"":`/${newId}`)); // blank

        // focus the first input field
        const nameEl:HTMLInputElement = document.getElementsByName("name")[0];
        if(nameEl) {
            nameEl.focus();
        }
    }
    
    function clearDirtyFlags() {
        setIsDirty(false);
        setPSetImage(new ImageInfoStruct()); // reset
    }
    
    function handleBackClicked() {
        if(isDirty) {
            Popup.showConfirm("Cancel?","You have changed some information.","Forget changes",null,
                () => {
                    setRedirectToPage("/adminPage");
                });
        }
        else {
            history.goBack();
        }
        
    }
    
    function setNewImageInfo(dataBytes) {

        const updatedImage = new ImageInfoStruct(dataBytes, true, null);
        setPSetImage(updatedImage);

        // and the profile set is actually dirty now too
        const editInfo = {...curSampleTypeDetails};
        editInfo.imageData= updatedImage.encodedBytes; // encoded string here
        setCurSampleTypeDetails(editInfo);
        setIsDirty(true);
    }
    
    if (redirectToPage) {
        return <Redirect to={redirectToPage}/>;
    }
    
    return (
        <div className="container">
            <Header hideAdmin/>
            <div className="li-header-row">
                <BackButton onClick={handleBackClicked}/>
                <h1 className="ml-4 d-inline-block align-middle">Sample Type Administration</h1>
            </div>
            
            <div className="row">
                {/* LEFT SIDE PICK LIST */}
                {showSampleTypesList(fullSampleTypesList)}

                {/* RIGHT SIDE FORM */}
                <div className="pl-4 w-60">
                    <div
                        className="li-fg-slightly-muted li-font-small text-right">[Id:{curSampleTypeDetails?.id ?? "-"}]
                    </div>

                    {/* right side, row #1 */}
                    <TextInput name="name" label="Name" onChange={(e) => onChange(e)}
                               placeholder="" textLeft maxLength={31}
                               value={curSampleTypeDetails?.name ?? ""}
                               required/>
                    {/* right side, row #2 */}
                    <TextInput name="description" label="Description" onChange={(e) => onChange(e)}
                               placeholder="" textLeft maxLength={128}
                               value={curSampleTypeDetails?.description ?? ""}
                               required/>

                    {/* right side, row #3 */}
                    <div className="">
                        <label className="li-form-label mr-3">Image</label>
                        <ImageSetterCard disabled={isSaving || curSampleTypeDetails.name === ""}
                                         imageInfo={pSetImage} onSaveClicked={setNewImageInfo}/>
                    </div>

                    {/* BUTTON ROW */}
                    <div className="text-center my-5">
                        <LIButton key="cancel" name="cancel" label={isDirty ? "Cancel" : "Clear"} bgClass="mr-4" primary
                                  onClick={handleCancelClicked}/>
                        <LIButton key="save" name="save" label={curSampleTypeDetails?.id === null ? "ADD" : "UPDATE"}
                                  secondary disabled={!isDirty || isSaving}
                                  onClick={(e) => handleSaveClicked(e, curSampleTypeDetails?.id === null ? "ADD" : "UPDATE")}
                                  showBusy={isSaving}/>
                    </div>
                </div>
            </div>


        </div>);
}

SampleTypesAdminPage.propTypes = {};

export default SampleTypesAdminPage;